import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./pdf-viewer.css";

type Props = {
  src: string;
};

export default function PdfViewer({ src }: Props) {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const pdfSrc = `${src}#view=FitH&zoom=page-width`;

  useEffect(() => {
    if (!isFullScreen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setIsFullScreen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isFullScreen]);

  return (
    <div className="pdf-viewer-root">
      <iframe src={pdfSrc} style={{ border: "none", width: "100%" }} />

      {/* <button type="button" className="pdf-fullscreen-btn" title="Full screen" onClick={() => setIsFullScreen(true)}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 3H5a2 2 0 0 0-2 2v3" />
          <path d="M21 8V5a2 2 0 0 0-2-2h-3" />
          <path d="M3 16v3a2 2 0 0 0 2 2h3" />
          <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
        </svg>
      </button> */}

      {isFullScreen &&
        createPortal(
          <div className="pdf-overlay" onClick={() => setIsFullScreen(false)}>
            <button type="button" className="pdf-close" title="Close" onClick={() => setIsFullScreen(false)}>
              ✕
            </button>
            <iframe src={pdfSrc} className="pdf-frame" onClick={(e) => e.stopPropagation()} />
          </div>,
          document.body
        )}
    </div>
  );
}
